// extracted by mini-css-extract-plugin
export default {"container":"style_container__UfQGY","fadeInDown":"style_fadeInDown__OxeQq","title":"style_title__KImbF","pizzaList":"style_pizzaList__8SDnz"};